import Home from './components/Home.vue';
import Project from './components/Project.vue';
import ProjectUsers from './components/ProjectUsers.vue';
import Profile from './components/Profile.vue';
import SysAdmin from './components/SysAdmin.vue';
import PurchaseOrders from './components/poviewer/PurchaseOrders.vue';
import PurchaseOrder from './components/poviewer/PurchaseOrder.vue';
import Journal from './components/journal/Journal.vue';
import StandaloneJournal from './components/journal/StandaloneJournal.vue';
import ProjectPhotos from './components/journal/ProjectPhotos.vue';
import Issues from './components/journal/Issues.vue';
import NotFound from './components/NotFound.vue';

const routes = [
  { path: '/', component: Home, name: 'Home', meta: { title: 'Canem Systems' } },
  { path: '/profile', component: Profile },
  { path: '/sysadmin', component: SysAdmin },
  {
    path: '/project/:id',
    name: "Project",
    component: Project,
    meta: { title: "Project" }
  },
  {
    path: '/project/:id/users',
    name: "ProjectUsers",
    component: ProjectUsers,
    meta: { title: "Project Users" }
  },  
  // {
  //   path: '/poviewer/:id',
  //   name: "PurchaseOrders",
  //   component: PurchaseOrders,
  // },
  {
    path: '/poviewer/:id/po/:poId',
    name: "PurchaseOrder",
    component: PurchaseOrder,
  },  
  {
    path: '/journal/:id/:date?',
    name: "Journal",
    component: Journal,
  },
  {
    path: '/standalonejournal/:id/:date?',
    name: "StandaloneJournal",
    component: StandaloneJournal,
  },  
  {
    path: '/photos/:id',
    name: "ProjectPhotos",
    component: ProjectPhotos,
  },  
  {
    path: '/issues/:id',
    name: "Issues",
    component: Issues,
  },    
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    meta: { title: 'Canem Systems - Not Found' }
  }
];

export default routes;